import React, { useEffect, useRef } from 'react';
import styles from './Modal.module.scss'
import { CloseIcon } from '../../assets/svg/CloseIcon';

type ModalProps = {
  header: string;
  onClose: () => void;
  children: React.ReactNode;
};

export const Modal: React.FC<ModalProps> = ({ header, onClose, children }) => {
  const overlayRef = useRef<HTMLDivElement>(null);
  const bodyRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (
        overlayRef.current &&
        bodyRef.current &&
        e.target instanceof Node &&
        overlayRef.current.contains(e.target) &&
        !bodyRef.current.contains(e.target)
      ) {
        onClose();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [onClose]);

  return (
    <div ref={overlayRef} className={styles.overlay}>
      <div ref={bodyRef} className={styles.body}>
        <div className={styles.header}>
          <div>
            {header}
          </div>
          <button className={styles.close} onClick={onClose}><CloseIcon /></button>
        </div>
        <div className={styles.children}>{children}</div>
      </div>
    </div>
  );
};
